import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
export function Constellation() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let animationFrameId: number;
    let width = canvas.offsetWidth;
    let height = canvas.offsetHeight;
    canvas.width = width;
    canvas.height = height;
    const nodes = [{
      x: 0.2,
      y: 0.3,
      vx: 0.1,
      vy: 0.1
    }, {
      x: 0.5,
      y: 0.2,
      vx: -0.1,
      vy: 0.2
    }, {
      x: 0.8,
      y: 0.4,
      vx: 0.2,
      vy: -0.1
    }, {
      x: 0.3,
      y: 0.7,
      vx: -0.2,
      vy: -0.2
    }, {
      x: 0.7,
      y: 0.8,
      vx: 0.1,
      vy: -0.1
    }, {
      x: 0.9,
      y: 0.6,
      vx: -0.1,
      vy: 0.1
    }, {
      x: 0.4,
      y: 0.5,
      vx: 0.1,
      vy: 0.2
    }];
    const draw = () => {
      ctx.clearRect(0, 0, width, height);
      // Update positions
      nodes.forEach(node => {
        node.x += node.vx * 0.01;
        node.y += node.vy * 0.01;
        if (node.x < 0 || node.x > 1) node.vx *= -1;
        if (node.y < 0 || node.y > 1) node.vy *= -1;
      });
      // Draw lines
      ctx.lineWidth = 1;
      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const dx = nodes[i].x - nodes[j].x;
          const dy = nodes[i].y - nodes[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 0.5) {
            ctx.beginPath();
            ctx.moveTo(nodes[i].x * width, nodes[i].y * height);
            ctx.lineTo(nodes[j].x * width, nodes[j].y * height);
            const opacity = (1 - dist / 0.5) * 0.3;
            ctx.strokeStyle = `rgba(212, 160, 74, ${opacity})`; // Gold color
            ctx.stroke();
          }
        }
      }
      // Draw nodes
      nodes.forEach(node => {
        ctx.beginPath();
        ctx.arc(node.x * width, node.y * height, 4, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(212, 160, 74, 0.6)';
        ctx.fill();
      });
      animationFrameId = requestAnimationFrame(draw);
    };
    draw();
    const handleResize = () => {
      width = canvas.offsetWidth;
      height = canvas.offsetHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener('resize', handleResize);
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return <div className="relative w-full h-full min-h-[400px]" data-id="element-29">
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" data-id="element-30" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.8,
      duration: 0.6
    }} className="absolute bottom-10 right-0 md:-right-10 bg-navy-card border border-navy-border p-6 rounded-sm shadow-2xl max-w-sm border-l-4 border-l-gold" data-id="element-31">
        <h3 className="text-white font-bold mb-2" data-id="element-32">
          Active Across 5 Continents
        </h3>
        <p className="text-sm text-slate-400 leading-relaxed" data-id="element-33">
          Facilitating procurement worldwide with a global network of verified
          manufacturers, exporters, and distributors, with strategic focus on
          emerging and high-growth markets.
        </p>
      </motion.div>
    </div>;
}